import _ from 'underscore';
import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';

export class ImageExtensionSourceColumn extends ProjectionGridBaseColumn {
  constructor({ i18n, newI18n }) {
    super({
      name: 'ImageExtensionSource',
      property: 'Opportunities/ImageExtensionSource',
      title: newI18n.getString(_TL_('Source')),
      bodyClasses: ['grid-column-ImageExtensionSource'],
      colClasses: ['col-longText'],
      sortable: 'Microsoft.Advertiser.AdInsight.Opportunity.Schema.ImageExtensionOpportunitySummary/ImageSourceStr',
      helpId: 'pop_BA_ImageExtension_Source',
      type: 'string',
      helpAriaLabel: i18n.getString('Click to learn more about source'),
    });
    this.newI18n = newI18n;
  }

  get property() {
    const { newI18n } = this;
    return {
      get(item) {
        const opportunity = _.first(item.Opportunities);
        return opportunity.ImageSourceStr === 'StockImage' ?
          newI18n.getString(_TL_('Stock images')) :
          newI18n.getString(_TL_('Website'));
      },
      key: 'Opportunities/ImageExtensionSource',
    };
  }
}
